import { render } from "./ParameterYesNo.vue?vue&type=template&id=3611d029"
import script from "./ParameterYesNo.vue?vue&type=script&lang=js"
export * from "./ParameterYesNo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__